import { Portuguese } from 'flatpickr/dist/l10n/pt'
import isEmpty from 'lodash/isEmpty'

const locales = {
  pt: Portuguese,
  en: 'default'
}

export default {
  name: 'DateBlock',
  components: {
    flatPickr: () => import('vue-flatpickr-component'),
    InputBlock: () => import('~/components/commom/input-block/index')
  },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: false,
      default: null
    },
    'is-date-picker': {
      type: Boolean,
      required: false,
      default: false
    },
    language: {
      type: String,
      required: false,
      default: 'pt'
    },
    'has-errors': {
      type: Boolean,
      required: false,
      default: false
    },
    disableDates: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      type: 'text'
    }
  },
  computed: {
    isTouch() {
      // eslint-disable-next-line no-unreachable
      if (!process.browser) {
        return false
      }

      if (
        !(
          'ontouchstart' in window ||
          // eslint-disable-next-line no-undef
          (window.DocumentTouch && document instanceof DocumentTouch)
        )
      ) {
        return false
      }

      return true
    },
    inputType() {
      if (this.isTouch) {
        return 'date'
      }

      return 'text'
    },
    hasValue() {
      return !isEmpty(this.modelDate) && this.isTouch
    },
    options() {
      const options = {
        altFormat: 'F j, Y',
        dateFormat: 'd/m/Y',
        locale: locales[this.language],
        allowInput: true,
        position: 'top'
      }

      // if (this.disableDates !== undefined) {
      //   options.disable = [this.disableDates];
      // }

      return options
    }
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value)
    },
    onBlur(value) {
      this.$emit('on-change', value.target.value)
      this.emitValue(value.target.value)
    },
    changeType(event) {
      // const element = this.$refs.inputMobile
      this.type = 'date'
    }
  }
}
